import type { ReactNode } from "react";
import { Link } from "react-router";
import { useAufgabeLink } from "../dialog";

/** Link auf eine Aufgabe in Listen: öffnet den Dialog über der aktuellen Seite (AUFGABEN-STUFE2.md, Abschnitt 6.1). */
export function AufgabeLink({ id, className, children, label }: { id: string; className?: string | undefined; children: ReactNode; label?: string | undefined }) {
  const link = useAufgabeLink();
  const ziel = link(id);
  return (
    <Link to={ziel.to} state={ziel.state} className={className} aria-label={label}>
      {children}
    </Link>
  );
}
